import '@iconify/iconify';
import './style.css';

// Load the componetns after the polyfill is importned and enabled
import('@webcomponents/webcomponentsjs/webcomponents-bundle.js').then(async () => {
    await import('./hub-website');
    await import('./hub-website-config');
});
